export const HIRING_LIST_PATHS = {
  OPEN:          "/hiring/open-jobs",
  CLOSED:        "/hiring/closed-jobs",
  DRAFT:         "/hiring/draft-jobs",
  ALL_REFERRALS: "/hiring/all-referrals",
  MY_REFERRALS:  "/hiring/my-referrals",
};

/** Human-readable name of the hiring list tab — used for "back to" labels. */
export const HIRING_LIST_LABELS = {
  OPEN:          "Open Jobs",
  CLOSED:        "Closed Jobs",
  DRAFT:         "Draft Jobs",
  ALL_REFERRALS: "All Referrals",
  MY_REFERRALS:  "My Referrals",
};

/** Resolve main hiring list URL from tab id (OPEN/CLOSED/DRAFT) or job status. */
export const getHiringListPath = (tabOrStatus) => {
  const key = String(tabOrStatus || "OPEN").toUpperCase();
  return HIRING_LIST_PATHS[key] || HIRING_LIST_PATHS.OPEN;
};

/** Resolve the previous page's display name from a tab id or job status. */
export const getHiringListLabel = (tabOrStatus) => {
  const key = String(tabOrStatus || "OPEN").toUpperCase();
  return HIRING_LIST_LABELS[key] || "Hiring";
};

/** Read the hiring tab the user came from — location state first, then job status. */
export const resolveFromHiringTab = (locationState, jobStatus) =>
  locationState?.fromHiringTab || jobStatus || "OPEN";
